var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiUploadLtr = function SvgUiUploadLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.85 86c1.187 0 2.15.895 2.15 2 0 1.085-.929 1.968-2.087 1.999H16.15c-1.187 0-2.15-.894-2.15-2 0-1.084.929-1.967 2.087-1.998L16.15 86zM49.79 10.146a2.17 2.17 0 0 1 1.563 0c.254.097.485.246.68.438l18.31 18.114c.86.847.876 2.236.037 3.103a2.16 2.16 0 0 1-3.073.036L52.67 17.343V72.81A2.18 2.18 0 0 1 50.5 75a2.18 2.18 0 0 1-2.17-2.19V17.343L33.692 31.837a2.16 2.16 0 0 1-3.074-.036 2.21 2.21 0 0 1 .036-3.103l18.457-18.114c.194-.192.426-.341.68-.438"
  })));
};
export default SvgUiUploadLtr;